import { LangKey } from "@vixi/localization";
import { Avatar } from "./Avatar";
import { CHARACTER_TYPE } from "@/enums/character_type";

export interface MarketingKitItem extends Avatar {
  characterType: Exclude<CHARACTER_TYPE, CHARACTER_TYPE.COURSE_CHARACTER>;
}

export function isMarketingKitItem(item: Avatar): item is MarketingKitItem {
  return item.characterType !== CHARACTER_TYPE.COURSE_CHARACTER;
}

export function marketingKitItemTitle(item: MarketingKitItem): LangKey {
  switch (item.characterType) {
    case CHARACTER_TYPE.INSTAGRAM_POST_CHARACTER:
      return "MarketingKit.InstagramPostSize";
    case CHARACTER_TYPE.INSTAGRAM_STORY_CHARACTER:
      return "MarketingKit.InstagramStorySize";
    case CHARACTER_TYPE.LINKEDIN_POST_CHARACTER:
      return "MarketingKit.LinkedInPostSize";
    default:
      throw new Error(`Unknown character type: ${item.characterType}`);
  }
}
